var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "viewer-layer" }, [
    _c("div", {
      staticClass: "viewer-layer-close-bg",
      attrs: { "aria-label": _vm.$t("close") },
      on: { click: _vm.closeEvent },
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viewer-layer-inner", class: _vm.innerClassName },
      [
        _vm._t("inner-extra"),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "viewer-layer-close",
            attrs: { "aria-label": _vm.$t("close") },
            on: { click: _vm.closeEvent },
          },
          [_c("icon", { staticClass: "icon-close-info-white" })],
          1
        ),
        _vm._v(" "),
        _vm._t("default"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }